import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { MyPromise } from '../../interceptors/myPromise.service';
import * as FileSaver from 'file-saver';
import { RecordSgm } from '../../pages/splasboard/sgm/data';
import * as moment from 'moment';

const URL = `${environment.baseEndpointPHP}`;

@Injectable({
  providedIn: 'root',
})
export class SgmService {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise
  ) { }


  getByStationIdAndKey (stationId: string, key: string, year: string | number = moment().year()) {
    return this.myPromise.to(this.http.get(`${URL}/sgm/${stationId}/${key}?year=${year}`));
  }

  create(
    stationId: string,
    data: Partial<RecordSgm & { data: any, year: string | number }>
  ) {
    return this.myPromise.to(this.http.post(`${URL}/sgm/${stationId}`, data));
  }

  update(
    id: string,
    data: Partial<RecordSgm & { data: any }>
  ) {
    return this.myPromise.to(this.http.put(`${URL}/sgm/${id}`, data));
  }

  delete(
    id: string,
  ) {
    return this.myPromise.to(this.http.delete(`${URL}/sgm/${id}`));
  }

  deleteByStationId(stationId) {
    return this.myPromise.to(this.http.delete(`${URL}/sgm/${stationId}`));
  }

  downloadFormat({stationId, category, file, id_item }: { stationId: string, category: string, file: string, id_item: string; }) {
    return new Promise(resolve => {
      this.http.get(`${URL}/sgm-resources/${stationId}`, {
        params: {
          category,
          file,
          id_item
        },
        headers: new HttpHeaders({
          'Content-Type': 'application/octet-stream',
        }), responseType: 'blob' as 'json', observe: 'response' as 'body',
      }).subscribe((response: any) => {
        const blob = new Blob([response.body]);
        FileSaver.saveAs(blob, `${category}_${file}.docx`);
        resolve(true);
      });
    });
  }

}